// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__29J0m","colCheckbox":"styles_colCheckbox__3GOi3"};